module.exports = __webpack_public_path__ + "static/media/sort.b0ef3c36.svg";